import { useContext } from 'react';
import {
  INVOICE_STATUS,
  MESSAGE_ATTACHMENT_REFERENCE_TYPES,
  MessageAttachment,
  MessageAttachmentWithTypedData,
} from '@typings/api-models';
import UserDocumentRequestCard from '@components/UserDocumentRequestCard';
import FormRequestCard from '@components/FormRequestCard';
import PaymentLinkButton from '@components/PaymentLinkButton';
import InvoiceCard from "@components/InvoiceCard";
import { DashboardContext } from '@layouts/DashboardLayout';

type Props = {
  creator: Parameters<typeof FormRequestCard>[0]['creator'];
  attachment: Pick<MessageAttachment, 'id' | 'referenceId' | 'canAccess'> & MessageAttachmentWithTypedData & {
    assigneeIds: string[];
  };
  isWorkflowAttachment?: boolean;
  reload?: () => Promise<void>;
  setIsFulfilled?: (f: boolean) => void;
};

const CommentAttachment: React.FC<Props> = ({ attachment, creator, isWorkflowAttachment, reload, setIsFulfilled }) => {
  const { isInDashboard } = useContext(DashboardContext);
  if (attachment.referenceType === MESSAGE_ATTACHMENT_REFERENCE_TYPES.DOCUMENT_REQUEST_USER) {
    return <UserDocumentRequestCard
      setIsFulfilled={setIsFulfilled}
      creatorSlug={creator.slug}
      canClick={!isWorkflowAttachment || attachment.canAccess}
      request={attachment.data}
    />;
  }
  if (attachment.referenceType === MESSAGE_ATTACHMENT_REFERENCE_TYPES.PAYMENT_LINK) {
    return (
      <PaymentLinkButton setIsFulfilled={setIsFulfilled} canClick={!isWorkflowAttachment || attachment.canAccess} data={attachment.data} />
    );
  }
  if (attachment.referenceType === MESSAGE_ATTACHMENT_REFERENCE_TYPES.FORM_REQUEST) {
    const { data } = attachment;
    return (
      <FormRequestCard
        setIsFulfilled={setIsFulfilled}
        canClick={!isWorkflowAttachment || attachment.canAccess}
        creator={creator}
        request={{
          ...data,
          person: { id: data.personId },
        }}
      />
    );
  }
  if (attachment.referenceType === MESSAGE_ATTACHMENT_REFERENCE_TYPES.INVOICE) {
    return (
      <InvoiceCard
        setIsFulfilled={setIsFulfilled}
        canClick={attachment.data.invoice.status === INVOICE_STATUS.IS_GENERATING
          ? attachment.canAccess
          : !isWorkflowAttachment || isInDashboard || attachment.canAccess}
        invoice={attachment.data.invoice}
        price={attachment.data.price}
        creatorSlug={creator.slug}
        reload={reload}
      />
    );
  }
  return null;
};

export default CommentAttachment;
